import moment from 'moment'

import currencies from './modules/currencies'
import currencyRates from './modules/currencyRates'
import deliveries from './modules/deliveries'
import deliveryItems from './modules/deliveryItems'
import inventoryArchive from './modules/InventoryArchive'
import inventory from './modules/inventory'
import inventoryDefinitions from './modules/inventoryDefinitions'
import suppliers from './modules/suppliers'
import productBuilds from './modules/productBuilds'
import production from './modules/production'
import productionOutputs from './modules/productionOutputs'
import productionInputs from './modules/productionInputs'
import customers from './modules/customers'
import addresses from './modules/addresses'
import sales from './modules/sales'
import salesItems from './modules/salesItems'
import users from './modules/users'

const state = {
  lastSync: null
}

const mutations = {
  UPDATE_DB_LAST_SYNC (state) {
    state.lastSync = moment().format()
  }
}

const actions = {
  updateDBLastSync: ({commit}) => {
    commit('UPDATE_DB_LAST_SYNC')
  }
  /*
  syncAllData: ({commit, dispatch}) => {
    return Promise.all([
      dispatch('currencies/fetchAll'),
      // dispatch('currencyRates/fetchAll'),
      // dispatch('deliveries/fetchAll'),


      // dispatch('deliveryItems/fetchAll'),
      // dispatch('inventory/fetchAll'),
      // dispatch('inventoryDefinitions/fetchAll'),
      // dispatch('inventoryArchive/fetchAll'),
      // dispatch('suppliers/fetchAll'),
      // dispatch('productBuilds/fetchBuilds'),
      // dispatch('productBuilds/fetchBuildItems'),
      // dispatch('production/fetchAll'),
      // dispatch('productionOutputs/fetchProductionOutputs'),
      // dispatch('productionInputs/fetchProductionInputs'),
      // dispatch('customers/fetchAll'),
      // dispatch('addresses/fetchAll'),
      // dispatch('sales/fetchAll'),
      // dispatch('salesItems/fetchAll'),
      // dispatch('users/fetchAll') 
    ])
      .then(() => {
        commit('UPDATE_DB_LAST_SYNC')
      })
  }*/
}

const getters = {
  sync: state => () => {
    var now = moment()
    var then = moment(state.lastSync)
    var diff = now.diff(then, 'seconds')
    if (isNaN(diff)) {
      return {
        synced: false,
        lastSync: null
      }
    }
    return {
      synced: true,
      lastSync: diff
    }
  }
}

const modules = {
  currencies,
  currencyRates,
  deliveries,
  deliveryItems,
  inventoryArchive,
  inventory,
  inventoryDefinitions,
  suppliers,
  productBuilds,
  production,
  productionOutputs,
  productionInputs,
  customers,
  addresses,
  sales,
  salesItems,
  users
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules
}
